
import { Component, Vue } from 'vue-property-decorator';

import Form5ProcessHeader from "@/components/process/Form5/components/Form5ProcessHeader.vue";
import Form5StyleOfProceeding from "@/components/process/Form5/components/Form5StyleOfProceeding.vue";
import { form5StatusInfoType } from '@/types/Information/Form5';

@Component({
    components:{
        Form5ProcessHeader,        
        Form5StyleOfProceeding
    }
})
export default class FillForm5 extends Vue {

    stepsCompleted = {} as form5StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
